
window.initHomeBannerSlider = function(sliderId) {
  var id = sliderId.slice(sliderId.indexOf('#') + 1);
  var elSwiper = document.getElementById(id);
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false; 
  }
  return new Swiper(elSwiper, {
    navigation: {
      nextEl: sliderId + ' .oa-home-banner__nav-next',
      prevEl: sliderId + ' .oa-home-banner__nav-prev',
      disabledClass: 'oa-home-banner__nav--disabled',
      hiddenClass: 'oa-home-banner__nav--disabled'
    },
    pagination: {
      el: sliderId + ' .oa-home-banner__pagination',
      clickable: true,
      bulletClass: 'oa-home-banner__bullet',
      bulletActiveClass: 'oa-home-banner__bullet--active'
    },
    slidesPerView: 1,
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    autoplay: {
      delay: 4000,
    },
    speed: 500,
    loop: true,
    lazyLoad: true,
    loadPrevNext: true,
  });
}

window.initProductSlider = function (sliderId) {
  var id = sliderId.slice(sliderId.indexOf('#') + 1);
  var elSwiper = document.getElementById(id);
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false; 
  }
  return new Swiper(elSwiper, {
    navigation: {
      nextEl: sliderId + ' + .oa-product-slider__nav .oa-product-slider__nav-next',
      prevEl: sliderId + ' + .oa-product-slider__nav .oa-product-slider__nav-prev',
      disabledClass: 'oa-product-slider__nav--disabled',
      hiddenClass: 'oa-product-slider__nav--disabled'
    },
    scrollbar: {
      el: '.oa-product-slider__scrollbar',
      // dragClass: 'oa-product-slider__scrollbar-drag',
      enabled: false,
      dragSize: 40,
      draggable: true,
      snapOnRelease: true,
    },
    slidesPerView: 2.25,
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    freeMode: true,
    freeModeSticky: false,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 3.5,
        scrollbar: {
           dragSize: 60,
        }
      },
      1300: {
        slidesPerView: 4,
        scrollbar: {
           dragSize: 60,
        },
      },
    },
    lazyLoad: true,
    loop: true
  });
}

window.initLpSlider = function (sliderId, sliderPerViewXS, sliderPerViewMD, sliderPerViewLG) {
  var id = sliderId.slice(sliderId.indexOf('#') + 1);
  var elSwiper = document.getElementById(id);
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false;
  }
  return new Swiper(elSwiper, {
    navigation: {
      nextEl: sliderId + ' + .oa-product-slider__nav .oa-product-slider__nav-next',
      prevEl: sliderId + ' + .oa-product-slider__nav .oa-product-slider__nav-prev',
      disabledClass: 'oa-product-slider__nav--disabled',
      hiddenClass: 'oa-product-slider__nav--disabled'
    },
    scrollbar: {
      el: '.oa-product-slider__scrollbar',
      // dragClass: 'oa-product-slider__scrollbar-drag',
      enabled: false,
      dragSize: 40,
      draggable: true,
      snapOnRelease: true,
    },
    /*enteredSlides: true,
    centeredSlidesBounds: true,*/
    slidesPerView: sliderPerViewXS,
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    freeMode: true,
    freeModeSticky: false,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true,
    },
    breakpoints: {
      992: {
        slidesPerView: sliderPerViewMD,
        scrollbar: {
          dragSize: 60,
        }
      },
      1300: {
        slidesPerView: sliderPerViewLG,
        scrollbar: {
          dragSize: 60,
        },
      },
    },
    lazyLoad: true
  });
}

window.onQuickAddSizeClicked = function (element, productId, productHandle) {
  var selectorContainer = '.oa-prdct20-fashion__quickadd-container',
      selectorItem = '.oa-quick-add__variants-item',
      selectorSizeItem = '.oa-quick-add__variants-size-wrapper .oa-quick-add__variants-item',
      selectorLengthTitle = '.oa-quick-add__title-length',
      selectorLengthWrapper = '.oa-quick-add__variants-length-wrapper',
      classSoldout = 'oa-quick-add__variants-item--soldout',
      classActive = 'oa-quick-add__variants-item--active',
      selectorItemActive = '.oa-quick-add__variants-item.oa-quick-add__variants-item--active',
      selectorWrapperDual = 'oa-prdct20-fashion__quickadd-container--duallogo';
  var elContainer = element.closest(selectorContainer);
  var size = element.dataset.quickaddSize.toLowerCase();
  var variants = JSON.parse(elContainer.dataset.variants).filter(function (variant) { return variant.title.toLowerCase().indexOf(size + ' -') === 0; });
  var elLengthWrapper = elContainer.querySelector(selectorLengthWrapper);
  var isDualLogo = elContainer.classList.contains(selectorWrapperDual);
//console.log(JSON.parse(elContainer.dataset.variants))
  if(isDualLogo){
    if(elLengthWrapper.querySelector(selectorItemActive) != null){
      elLengthWrapper.querySelector(selectorItemActive).classList.remove(classActive);
      
  var selectorDualTitle = '.oa-quick-add__title-duallogo',
      selectorDualWrapper = '.oa-quick-add__variants-duallogo-wrapper',
      elDualWrapper = elContainer.querySelector(selectorDualWrapper),
      elDualTitle = elContainer.querySelector(selectorDualTitle);
      elDualTitle.style.position = 'absolute';
      elDualTitle.style.zIndex = -1;
      elDualWrapper.style.position = 'absolute';
      elDualWrapper.style.zIndex = -1;
    }
  }
  
  Array.prototype.slice.call(elLengthWrapper.querySelectorAll(selectorItem)).forEach(function (el) {
    var length = el.dataset.quickaddLength.toLowerCase();
    var a11yTpl = el.getAttribute('data-a11y-label');
    if (a11yTpl) {
      el.setAttribute('aria-label', a11yTpl.split('{size}').join(size.toUpperCase()));
    }
    if(isDualLogo){
      var dualVariants = variants.filter(function (variant) { return variant.title.toLowerCase().indexOf('- ' + length) !== -1; });

    var avilableLengths = [];
      
dualVariants.forEach(function(variant){
  if (!variant) {
      el.style.display = 'none'; 
      return;
    }
    el.style.display = null;
    var elSvg = el.querySelector('svg');
  //console.log(variant.title,variant.available)
  
    if (!variant.available && avilableLengths.indexOf(variant.title.split(' - ')[1]) == -1) {
      el.classList.add(classSoldout);
      el.setAttribute('disabled', true);
      elSvg.style.display = null;
      el.removeAttribute('data-quickadd-variant-selected-size');
      return;
    }
      avilableLengths.push(variant.title.split(' - ')[1])
      el.classList.remove(classSoldout);
      el.removeAttribute('disabled');
      elSvg.style.display = 'none';
      el.setAttribute('data-quickadd-variant-selected-size', size); 
    
});
      
    }else{
    var variant = variants.filter(function (variant) { return variant.title.toLowerCase().indexOf('- ' + length) !== -1; })[0];
    //console.log(variant)
    if (!variant) {
      el.style.display = 'none'; 
      return;
    }
    el.style.display = null;
    var elSvg = el.querySelector('svg');
    if (!variant.available) {
      el.classList.add(classSoldout);
      el.setAttribute('disabled', true);
      elSvg.style.display = null;
      el.removeAttribute('data-quickadd-variant-id');
      return;
    }
      //console.log(variant)
      el.classList.remove(classSoldout);
      el.removeAttribute('disabled');
      elSvg.style.display = 'none';
      el.setAttribute('data-quickadd-variant-id', variant.id); 
    }
  });
  
  Array.prototype.slice.call(elContainer.querySelectorAll(selectorSizeItem)).forEach(function (el) { el.classList.remove(classActive); });
  //console.log(Array.prototype.slice.call(elContainer.querySelectorAll(selectorSizeItem)))
  element.classList.add(classActive);
  var elLengthTitle = elContainer.querySelector(selectorLengthTitle);
  
  elLengthTitle.style.position = null;
  elLengthTitle.style.zIndex = null;
  elLengthWrapper.style.position = null;
  elLengthWrapper.style.zIndex = null;

}

window.onQuickAddLengthToDualClicked = function (element, productId, productHandle) {
  var selectorContainer = '.oa-prdct20-fashion__quickadd-container',
      selectorItem = '.oa-quick-add__variants-item',
      selectorLengthItem = '.oa-quick-add__variants-length-wrapper .oa-quick-add__variants-item',
      classSoldout = 'oa-quick-add__variants-item--soldout',
      classActive = 'oa-quick-add__variants-item--active';
  var elContainer = element.closest(selectorContainer);
  var length = element.dataset.quickaddLength.toLowerCase();
  var selectedSize = elContainer.querySelector('.oa-quick-add__variants-size-wrapper .oa-quick-add__variants-item--active').dataset.quickaddSize
  var variants = JSON.parse(elContainer.dataset.variants).filter(function (variant) {return variant.title.toLowerCase().indexOf(length + ' -') !== -1 && variant.title.toLowerCase().indexOf(selectedSize + ' -') === 0; });

  //console.log(variants)

  var selectorDualTitle = '.oa-quick-add__title-duallogo',
      selectorDualWrapper = '.oa-quick-add__variants-duallogo-wrapper',
      elDualWrapper = elContainer.querySelector(selectorDualWrapper);
   
  
  Array.prototype.slice.call(elDualWrapper.querySelectorAll(selectorItem)).forEach(function (el) {
    var logo = el.dataset.quickaddLogo.toLowerCase();
    var a11yTpl = el.getAttribute('data-a11y-label');
    if (a11yTpl) {
      el.setAttribute('aria-label', a11yTpl.split('{size}').join(selectedSize.toUpperCase()));
    }
    var variant = variants.filter(function (variant) { return variant.title.toLowerCase().indexOf('- ' + logo) !== -1; })[0];
    
    
    if (!variant) {
      el.style.display = 'none'; 
      return;
    }
    el.style.display = null;
    var elSvg = el.querySelector('svg');
    
    if (!variant.available) {
      el.classList.add(classSoldout);
      el.setAttribute('disabled', true);
      elSvg.style.display = null;
      el.removeAttribute('data-quickadd-variant-id');
      return;
    }
    el.classList.remove(classSoldout);
    el.removeAttribute('disabled');
    elSvg.style.display = 'none';
    //console.log(variant)
    el.setAttribute('data-quickadd-variant-title', variant.title);
    el.setAttribute('data-quickadd-variant-id', variant.id);
  });
  
  Array.prototype.slice.call(elContainer.querySelectorAll(selectorLengthItem)).forEach(function (el) { el.classList.remove(classActive); });
  element.classList.add(classActive);
  
  var elDualTitle = elContainer.querySelector(selectorDualTitle);


  elDualTitle.style.position = null;
  elDualTitle.style.zIndex = null;
  elDualWrapper.style.position = null;
  elDualWrapper.style.zIndex = null;

}
window.onQuickAddLengthClicked = function (element, productHandle, productTitle, productImage) {
  var variantId = element.dataset.quickaddVariantId;
  if (!variantId) { return; }
  window.onQuickAddClicked(element, variantId, productHandle, productTitle, productImage);
}

window.onQuickAddDualLogoClicked = function (element, productHandle, productTitle, productImage) {
  var variantId = element.dataset.quickaddVariantId;
  //console.log(variantId,element.dataset.quickaddVariantTitle);
  //console.log(element);
  
  //return;
  if (!variantId) { return; }
  window.onQuickAddClicked(element, variantId, productHandle, productTitle, productImage);
}

function closeQuickAddSizeAndLength (prodid) {
  var selectorContainer = '.oa-prdct20-fashion__quickadd-container',
      selectorItem = '.oa-quick-add__variants-item',
      selectorSizeItem = '.oa-quick-add__variants-size-wrapper .oa-quick-add__variants-item',
      selectorLengthTitle = '.oa-quick-add__title-length',
      selectorLengthWrapper = '.oa-quick-add__variants-length-wrapper',
      selectorDualTitle = '.oa-quick-add__title-duallogo',
      selectorDualWrapper = '.oa-quick-add__variants-duallogo-wrapper',
      classSoldout = 'oa-quick-add__variants-item--soldout',
      classActive = 'oa-quick-add__variants-item--active';
  var element = document.querySelector('.oa-shop-grid__item[data-product-id="'+prodid+'"] .oa-prdct20-fashion__quickadd-container');
  var elContainer = element.closest(selectorContainer);
  var elLengthWrapper = elContainer.querySelector(selectorLengthWrapper);
  var isDualLogo = element.dataset.quickaddLogo !== undefined;


  if (!elLengthWrapper) { return; }
  elLengthWrapper.style.zIndex = -1;
  elLengthWrapper.style.position = 'absolute';
  var elLengthTitle = elContainer.querySelector(selectorLengthTitle);
  elLengthTitle.style.zIndex = -1;
  elLengthTitle.style.position = 'absolute';
  Array.prototype.slice.call(elLengthWrapper.querySelectorAll(selectorItem)).forEach(function (el) { el.style.display = 'none'; });
  Array.prototype.slice.call(elContainer.querySelectorAll(selectorSizeItem)).forEach(function (el) { el.classList.remove(classActive); });

    if(!isDualLogo){ return; }
      var elDualWrapper = elContainer.querySelector(selectorDualWrapper);
      var elDualTitle = elContainer.querySelector(selectorDualTitle);
    if (!elDualWrapper) { return; }
      elDualWrapper.style.zIndex = -1;
      elDualWrapper.style.position = 'absolute';
      elDualTitle.style.zIndex = -1;
      elDualTitle.style.position = 'absolute';
  
}

// window.onQuickAddClicked = function (element, variantId, productHandle, productTitle, productImage) {
//   var selectorContainer = '.oa-prdct20-fashion__quickadd-container',
//       classActive = 'oa-quick-add__variants-item--active',
//       classSuccess = 'oa-quick-add__success',
//       classAdding = 'oa-quick-add__success--adding',
//       classAdded = 'oa-quick-add__success--added';
//   if (element.classList.contains(classActive) || element.hasAttribute('disabled')) {
//     return;
//   }
//   var elContainer = element.closest(selectorContainer);
//   elContainer.style.opacity = 1;
//   element.classList.add(classActive);
//   var addToCartData = { id: variantId, quantity: 1 };
//   if (Cookies.get('adfb') !== undefined){
//     addToCartData = { id: variantId,
//                      quantity: 1,
//                      properties: {'ad': 'FB'}
//                     };
//   }else if(Cookies.get('adig') !== undefined){
//     addToCartData = { id: variantId,
//                      quantity: 1,
//                      properties: {'ad': 'IG'}
//                     };
//   }
//   axios.post('/cart/add.json', addToCartData)
//   .then(function (response) {
//     //console.log('quick add product', variantId);
//     var circleSvg = '<svg class="oa-quick-add__success--circle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="25"></circle></svg>';
//     var loadingSvg = '<svg class="oa-quick-add__success--check" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polyline points="11.6,20 15.9,24.2 26.4,13.8"></polyline></svg>';
//     var domString = '<div class="' + classSuccess + '">' + circleSvg + loadingSvg + '</div>';
//     var parser = new DOMParser();
//     var elSuccess = parser.parseFromString(domString, 'text/html').body.firstChild;
//     document.dispatchEvent(new CustomEvent('oa:addtocartsuccess', { detail: { quickadd: true, handle: productHandle, title: productTitle, image: productImage } }));
//     document.dispatchEvent(new CustomEvent('oa:addtocarttracking', { detail: { sku: response.data.sku, qty: '1', title: productTitle, prodID: response.data.product_id, variantID: response.data.variant_id } }));
//     element.appendChild(elSuccess);
//     elSuccess.classList.add(classAdding);
//     setTimeout(function () {
//       elSuccess.classList.add(classAdded);
//       setTimeout(function () {
//         window.oaHeader.showCartCheck(element, function () {
//           elSuccess.classList.remove(classAdding);
//           elSuccess.classList.remove(classAdded);
//           setTimeout(function () {
//             element.removeChild(elSuccess);
//             element.classList.remove(classActive);
//             closeQuickAddSizeAndLength(response.data.product_id);
//             elContainer.style.opacity = null;
//           }, 225);
//         }, true);
//       }, 225);
//     }, 1000);
//   })
//   .catch(function () {
//     element.classList.remove(classActive);
//     elContainer.style.opacity = null;
//   });
// }

window.onQuickAddToggle = function (element) {
  element.classList.toggle('oa-quick-add__toggle--active');
  $(element.nextElementSibling).slideToggle(225);
}

document.addEventListener('DOMContentLoaded', function () {
  var homeBanners = document.querySelectorAll('.swiper-container.oa-home-banner[id^="home_banner"]');
  homeBanners.forEach(homeBanner => {
    window.initHomeBannerSlider('#' + homeBanner.id);
  });

  // window.initProductSlider('#recom_slider_sportswear');
  // window.initProductSlider('#recom_slider');

  // setTimeout(function () {
  //   window.initProductSlider('#newin_slider_sportswear');
  //   window.initProductSlider('#newin_slider');
  // }, 400);

 
  if (window.initProductSlider) {
    var recoSliders = document.querySelectorAll('.swiper-container.oa-product-slider__swiper[id^="reco_slider"]');
    recoSliders.forEach(recoSlider => {
      window.initProductSlider('#' + recoSlider.id);
    });
    /*
    window.initLpSlider('#reco_slider--teasing-raw-1', 2, 4, 4);
    window.initLpSlider('#reco_slider--teasing-raw-2', 2, 4, 4);
    window.initLpSlider('#reco_slider--teasing-raw-3', 2, 4, 4);
     */
    
  } 

  setTimeout(function () {
    if (window.initCabSlider) {
      window.initCabSlider();
    }

  }, 500);
}, { passive: true });





function createHtml(variant,colorName,element="",isActive,isLimited=false){
  const changeColorAttr = element === "-sidebar"
    ? `onclick="sidebar.fashionColorChange('${variant.handle}')"`
    : `href="/products/${variant.handle}" onclick="if(window.oaPdpColorSwitch){event.preventDefault();window.oaPdpColorSwitch.switchColor('${variant.handle}')}"`;

  const _newBadgeA = window.abtest && window.abtest.newBadgeVersion == 'a';
  let itemHtml = `
            <div class="sidebar--color-item-box" style="${_newBadgeA ? 'margin-bottom:0' : ''}" onmouseover="writeColorNameHower( '${colorName}' , '${element}' , true , ${isLimited})" onmouseout="writeColorNameHower('${colorName}' , '${element}', false , ${isLimited} )">  <a   ${changeColorAttr} style="order: 0;position: relative"  class="sidebar--color-item m-b-0 ${isActive ? ' active' : ''}">

                <div style="position: relative;" class="sidebar--color-item-bg ${!variant.inventory_available ? ' item--sold-out' : ''}"
                     data-handle="${variant.handle}" data-bgcolor="${colorName}"
                     >
                     ${!variant.inventory_available ? `<svg  style="color:white;width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0; inset: 0;" fill="currentColor" stroke="currentColor">
                      <line x1="0" y1="100%" x2="100%" y2="0" style="stroke-width:1"></line>
                    </svg>` : ''}

                </div>
              </a><div class="sidebar--color-item-text" style="${_newBadgeA ? 'display:block' : ''}">${variant.tags && variant.tags.includes('new') ? 'new' : ''}</div></div>
            `;
  return itemHtml;
} 
function createLoadMore(count,isLimited=false,element = "")
{
  return `<div class="oa-fashion-show-more-color" id="${isLimited?'oa-fashion-show-more-limited-color'+element:'oa-fashion-show-more-color'+element}">
    <div class="">
      <span>+${count}</span>
      <div
        class="oa-fashion-show-more-txt smaller">Colors</div>
    </div>
  </div>`
}
function ActiveLoadMore(count,isLimited=false,element = "")
{
 // console.log("ActiveLoadMore",count,isLimited,element)
  let productsContainer
  let showMoreBtn
if(isLimited){
   productsContainer = document.getElementById('fashion-color-limited-switch'+element);
   showMoreBtn = document.getElementById('oa-fashion-show-more-limited-color'+element);
}else{
   productsContainer = document.getElementById('fashion-color-switch'+element);
   showMoreBtn = document.getElementById('oa-fashion-show-more-color'+element);
}
 // console.log("productsContainer",productsContainer,showMoreBtn)
const allItems = Array.from(productsContainer.getElementsByClassName('item'));
const itemsPerRow = 6;
const visibleRows = 3;
const initialVisibleItems = (itemsPerRow * visibleRows)-1;
if(allItems.length<= initialVisibleItems){
  // showMoreBtn.style.display = 'none';
  return
}
//  console.log("allItems",allItems)
const calculateHeightForItems = (itemsCount) => {
  let height = allItems[0].offsetHeight+4
  return height * (itemsCount/itemsPerRow);
  productsContainer.style.overflow = ''
};
const initialHeight = calculateHeightForItems(initialVisibleItems+1);
productsContainer.style.height = `${initialHeight}px`;
// console.log("initialHeight",initialHeight)
showMoreBtn.addEventListener('click', () => {
  const fullHeight = calculateHeightForItems(allItems.length);
 // console.log("fullHeight",fullHeight)
  productsContainer.style.height = `${fullHeight}px`;
  showMoreBtn.style.display = 'none';

  productsContainer.style.overflow = '';
  setTimeout(()=>{
    productsContainer.style.height = `auto`;
  },220)
});
}
function renderLimitedEditionVariants(variants, productHandle, productTitle, element = "") {
  const currentProduct = productHandle;
  const isCurrentProductLimited = variants.some(v => v.handle === currentProduct);


  const limitedEditionHtml = `
          ${variants.map((variant, index) => {
    if (variant.handle === productHandle && element != "-sidebar") return;
    const titleParts = variant.title.split('|');
    const colorName = titleParts[1] ? titleParts[1].trim() : '';
    const isActive = variant.handle === currentProduct;
    return createHtml(variant,colorName,element,variant.handle === productHandle,true);
  }).join('')}`;


  if (variants.length > 0) {
    document.querySelectorAll('.is-not-limited'+element).forEach(function(element) {
      element.classList.remove('d-none');
    });
    document.querySelectorAll('.is-limited'+element).forEach(function(element) {
      element.classList.add('d-none');
    });
    let colorSwitch = document.getElementById('fashion-color-limited-switch'+element);
    colorSwitch.insertAdjacentHTML('beforeend', limitedEditionHtml);
  }else{
    document.querySelectorAll('.is-not-limited'+element).forEach(function(element) {
      element.classList.add('d-none');
    });

    document.querySelectorAll('.is-limited'+element).forEach(function(element) {
      element.classList.remove('d-none');
    });
  }


}

function renderColorVariants(variants,productHandle,element="") {
  const currentProduct = productHandle;
  const colorSwitch = document.getElementById('fashion-color-switch'+element);
  if (!colorSwitch) return;
  const items = colorSwitch.querySelectorAll('.item:not(:first-child)');
  items.forEach(item => item.remove());
  let itemHtml="";
  var soldOutHtmlParts = [];
  var soldOutCount = 0;
  variants.forEach((variant,index) => {
    if (variant.handle === productHandle && element != "-sidebar") return;
    const titleParts = variant.title.split('|');
    const colorName = titleParts[1] ? titleParts[1].trim() : '';
    if (!variant.inventory_available && variant.handle !== productHandle) {
      soldOutCount++;
      soldOutHtmlParts.push(createHtml(variant,colorName,element,false,false));
    } else {
      colorSwitch.insertAdjacentHTML('beforeend', createHtml(variant,colorName,element , variant.handle === productHandle,false));
    }
  });
  if (soldOutCount > 0) {
    var toggleId = 'oa-soldout-toggle' + element;
    var wrapperId = 'oa-soldout-colors' + element;
    var htmlEl = document.documentElement;
    var colorWord;
    if (htmlEl.classList.contains('oa-de')) {
      colorWord = soldOutCount === 1 ? 'Farbe' : 'Farben';
    } else if (htmlEl.classList.contains('oa-uk')) {
      colorWord = soldOutCount === 1 ? 'Colour' : 'Colours';
    } else {
      colorWord = soldOutCount === 1 ? 'Color' : 'Colors';
    }
    colorSwitch.insertAdjacentHTML('beforeend',
      '<div class="sidebar--color-item-box sidebar--color-soldout-toggle" id="' + toggleId + '" style="cursor:pointer;" onclick="document.getElementById(\'' + wrapperId + '\').style.display=\'flex\';this.style.display=\'none\';">' +
        '<span class="sidebar--color-soldout-toggle__text">+ ' + soldOutCount + ' ' + colorWord + '</span>' +
      '</div>' +
      '<div id="' + wrapperId + '" class="oa-soldout-colors-wrapper" style="display:none;flex-wrap:wrap;">' +
        soldOutHtmlParts.join('') +
      '</div>'
    );
  }
}


async function initColorVariants(productTitle,productHandle,algoliaAppId,algoliaApiKey,algoliaIndex,element="") {
  let indexName
  let selectedColorData
  let response
  const client = window.OAAlgoliaApi.getClient(algoliaAppId, algoliaApiKey);
  if (! window?.oaAlgolia?.activeIndex) {
    indexName = algoliaIndex;
  } else {
    indexName = window?.oaAlgolia?.activeIndex
  }

  try {
    if(element == "-sidebar"){
      // console.log("bef filt",response)
      // response = response.hits.filter(hit => hit.inventory_available)

      if(colorsData){
        selectedColorData = findFirstMatchingParent(colorsData , productTitle[0].trim())
      }
      if(selectedColorData){
        response = selectedColorData?.hits
      }else{
        response = await client.search({
          requests: [{
            indexName: indexName,
            query: '',
            filters: window.OAAlgoliaApi.filters.and([
              window.OAAlgoliaApi.filters.facetFilter('tags', 'color-sorting'),
              window.OAAlgoliaApi.filters.facetFilter('meta.custom.nosto_title', window.OAAlgoliaApi.filters.quote(removeWhiteLogo(productTitle[0].trim()))),
            ]),
            ruleContexts: ['color-sorting'],
            analytics: false,
            hitsPerPage: 1000,
          }]
        });
        response = response.results[0];
        response = await window.transformAppAlgoliaSearchResponse(response);
        response = await window.transformPreviewLaunchTagAlgoliaSearchResponse(response);
        response = response?.hits
      }

      //  console.log("after filt",response)
    }else{
      response = await client.search({
        requests: [{
          indexName: indexName,
          query: '',
          filters: `tags:color-sorting AND meta.custom.nosto_title:'${removeWhiteLogo(productTitle[0].trim())}'`,
          ruleContexts: ['color-sorting'],
          analytics: false,
          hitsPerPage: 1000,
        }]
      });
      response = response.results[0];
      response = await window.transformAppAlgoliaSearchResponse(response);
      response = await window.transformPreviewLaunchTagAlgoliaSearchResponse(response);
      response = response?.hits
    }
   
    if ( response) {

      const { regularVariants, limitedVariants } = separateVariants(response);
      renderLimitedEditionVariants(limitedVariants,productHandle,productTitle,element);
      renderColorVariants(regularVariants,productHandle,element);

      // Preload all color variant product data for instant switching
      if (window.oaPdpColorSwitch && element !== "-sidebar") {
        const allHandles = response.map(function(v) { return v.handle; }).filter(Boolean);
        window.oaPdpColorSwitch.preload(allHandles);
      }
    }
  } catch (error) {
    console.error('Error fetching color variants:', error);
  }
}
function createFirstElement(product, fashiontitleParts,element="") {
  let itemHtml = "";
  let colorSwitch;

  const _newBadgeA = window.abtest && window.abtest.newBadgeVersion == 'a';
  const _soldOut = !product.available;
  itemHtml = `<div class="sidebar--color-item-box" style="${_newBadgeA ? 'margin-bottom:0' : ''}"><a href="/products/${product.handle}" onclick="if(window.oaPdpColorSwitch){event.preventDefault();window.oaPdpColorSwitch.switchColor('${product.handle}')}" class="sidebar--color-item m-b-0 active"><div ${_soldOut ? 'style="position: relative;" ' : ''}class="sidebar--color-item-bg${_soldOut ? ' item--sold-out' : ''}" data-handle="${product.handle}" data-bgcolor="${fashiontitleParts[1].trim()}">${_soldOut ? `<svg style="color:white;width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0; inset: 0;" fill="currentColor" stroke="currentColor"><line x1="0" y1="100%" x2="100%" y2="0" style="stroke-width:1"></line></svg>` : ''}</div></a><div class="sidebar--color-item-text" style="${_newBadgeA ? 'display:block' : ''}">${product.tags.includes('new') ? 'new' : ''}</div></div>`;
  document.getElementById('fashion-color-limited-switch'+element).innerHTML="";
  document.getElementById('fashion-color-switch'+element).innerHTML="";
  if (product.tags.includes('limited-edition')) {
    colorSwitch = document.getElementById('fashion-color-limited-switch'+element);
    document.getElementById('limited-color-text'+element).innerHTML = ' '+fashiontitleParts[1].trim();
    document.getElementById('regular-color-text'+element).innerHTML = '';
  } else {
    colorSwitch = document.getElementById('fashion-color-switch'+element);
    document.getElementById('limited-color-text'+element).innerHTML = '';
    document.getElementById('regular-color-text'+element).innerHTML = ' '+fashiontitleParts[1].trim();
  }
  if(element == "-sidebar"){return}
  colorSwitch.insertAdjacentHTML('beforeend', itemHtml);
}
function separateVariants(variants) {
  const regularVariants = [];
  const limitedVariants = [];

  variants.forEach(variant => {
    if (variant.tags.includes('limited-edition')) {
      limitedVariants.push(variant);
    } else {
      regularVariants.push(variant);
    }
  });

  return { regularVariants, limitedVariants };
}
function writeColorNameHower(colorName,element,status,isLimited=false ){
  if(status){
    if(!isLimited){
      document.getElementById('fashion-color-switch-item-title'+element).innerHTML =` ${colorName}`;
      document.getElementById('regular-color-text'+element).innerHTML =` ${colorName}`;
    }else{
      document.getElementById('limited-color-text'+element).innerHTML =` ${colorName}`;
    }
  }else{
    if(!isLimited){
      var color_switch_slider = document.getElementById('fashion-color-switch'+element);
      var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.sidebar--color-item-box .active .sidebar--color-item-bg '));
      var current_title = color_items[0]?.getAttribute('data-bgcolor');
      document.getElementById('fashion-color-switch-item-title'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
      document.getElementById('regular-color-text'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
    }else{
      var color_switch_slider = document.getElementById('fashion-color-limited-switch'+element);
      var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.sidebar--color-item-box .active .sidebar--color-item-bg '));
      var current_title = color_items[0]?.getAttribute('data-bgcolor');
      document.getElementById('limited-color-text'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
    }
  }
}
function changeActiveColor(handle, element, isLimited) {
  var color_switch_slider_el
  var other_color_switch_slider_el
  if(isLimited){
    color_switch_slider_el = document.getElementById('fashion-color-limited-switch'+element);
    other_color_switch_slider_el = document.getElementById('fashion-color-switch'+element);
  }else{
    color_switch_slider_el = document.getElementById('fashion-color-switch'+element);
    other_color_switch_slider_el = document.getElementById('fashion-color-limited-switch'+element);
  }
  const currentActive = color_switch_slider_el.querySelector('.sidebar--color-item.active');
  if (currentActive) {
    currentActive.classList.remove('active');
  }

  if (other_color_switch_slider_el) {
    other_color_switch_slider_el.querySelector('.sidebar--color-item.active')?.classList.remove('active');
  }
  const newActiveElement = color_switch_slider_el.querySelector(`[data-handle="${handle}"]`).parentElement;
  newActiveElement.classList.add('active');


  const colorName = color_switch_slider_el.querySelector(`[data-handle="${handle}"]`).getAttribute('data-bgcolor');


  if (!isLimited) {
    document.getElementById('limited-color-text' + element).innerHTML = "";
    document.getElementById('fashion-color-switch-item-title' + element).innerHTML = ` ${colorName}`;
    document.getElementById('regular-color-text' + element).innerHTML = ` ${colorName}`;
  } else {
    document.getElementById('fashion-color-switch-item-title' + element).innerHTML = "";
    document.getElementById('regular-color-text' + element).innerHTML = "";
    document.getElementById('limited-color-text' + element).innerHTML = ` ${colorName}`;
  }
}

var filterAnimation;
function initFilterAnimation() {
  if (typeof gsap === "undefined") {
    setTimeout(initFilterAnimation, 50);
    return;
  }
  filterAnimation = (function () {
    var sidebar = document.getElementById("shop-filter-sidebar");
    var collection = document.querySelector(".oa-shop-products-collection");
    var btnTextShow = Array.from(document.querySelectorAll(".filter-btn-label-show"));
    var btnTextHide = Array.from(document.querySelectorAll(".filter-btn-label-hide"));

    var openAnimation = gsap.timeline({
      paused: true,
      onComplete: function () {
        sidebar.style.overflow = "visible";
        sidebar.classList.add("visible");
        animationIsActive = false;
        window.dispatchEvent(new Event('resize'));
      }
    })
      .to(sidebar, {
        width: "20%",
        duration: 0.4,
        ease: "power1.inOut",
        marginRight: "30px",
        display: "block"
      })
      .to(sidebar, {
        height: "calc(100vh - 140px)",
        duration: 0.2,
        ease: "power1.inOut"
      }, 0.2)
      .to(collection, {
        width: "80%",
        duration: 0.2,
        ease: "power1.inOut"
      }, 0.2);

    var closeAnimation = gsap.timeline({
      paused: true,
      onComplete: function () {
        sidebar.classList.remove("visible");
        sidebar.style.display = "none";
        animationIsActive = false;
        window.dispatchEvent(new Event('resize'));
      }
    })
      .to(sidebar, {
        height: "0px",
        duration: 0.4,
        ease: "power1.inOut"
      })
      .to(sidebar, {
        width: "0%",
        // minWidth: "0",
        marginRight: "0px",
        duration: 0.2,
        ease: "power1.inOut"
      }, 0.2)
      .to(collection, {
        width: "100%",
        duration: 0.2,
        ease: "power1.inOut"
      }, 0.2);

    function openSidebar() {
      if (openAnimation.isActive() || closeAnimation.isActive()) {
        return; // Prevent overlapping animations
      }

      openAnimation.restart();

      collection.offsetHeight;
      btnTextShow.forEach((btn) => btn.classList.add("hidden"));
      btnTextHide.forEach((btn) => btn.classList.remove("hidden"));
      sidebar.dataset.collapsed = "false";
    }

    function closeSidebar() {
      if (openAnimation.isActive() || closeAnimation.isActive()) {
        return; // Prevent overlapping animations
      }

      closeAnimation.restart();

      collection.offsetHeight;
      btnTextShow.forEach((btn) => btn.classList.remove("hidden"));
      btnTextHide.forEach((btn) => btn.classList.add("hidden"));
      sidebar.dataset.collapsed = "true";
    }

    return {
      openSidebar: openSidebar,
      closeSidebar: closeSidebar
    };
  })();
}
initFilterAnimation();

function toggleFilterPLP() {
  var sidebar = document.getElementById("shop-filter-sidebar");

  // Ensure GSAP is loaded
  if (typeof gsap === "undefined") {
    console.error("GSAP is not loaded. Please include GSAP library.");
    return;
  }

  // Initialize if not already done
  if (!sidebar.dataset.initialized) {
    sidebar.style.overflow = "hidden";
    sidebar.dataset.initialized = "true";
    sidebar.dataset.collapsed = "true";
  }

  const isCollapsed = sidebar.dataset.collapsed === "true";
  sidebar.style.overflow = "hidden";
  sidebar.classList.remove("visible");

  if (isCollapsed) {
    filterAnimation.openSidebar();
  } else {
    filterAnimation.closeSidebar();
  }
}

// TODO: This could also be done with a js variable, that is set on page load and when filters are switched manually. Then it could also be used for showing the category title conditionally.
function isVersionA(element) {
  return $(element).parents('.oa-shop-filter__version-a').length > 0;
}

function toggleFilterPLPVerA() {
  const filterTitle = document.querySelector('.oa-shop-filter__title-plp');
  const filterMain = document.getElementById('oa-shop-filter__main');

  // Initialize if not already done
  if (!filterMain.dataset.initialized) {
    filterMain.style.transition = 'height 0.3s ease';
    filterMain.style.overflow = 'hidden';
    filterMain.dataset.initialized = 'true';
    filterMain.dataset.collapsed = 'false';
  }

  const isCollapsed = filterMain.dataset.collapsed === 'true';

  if (isCollapsed) {
    // Expand - temporarily remove height restriction to measure content
    filterMain.style.height = 'auto';
    const scrollHeight = filterMain.scrollHeight;
    filterMain.style.height = '0px';

    // Force reflow, then animate to full height
    filterMain.offsetHeight; // Trigger reflow
    filterMain.style.height = scrollHeight + 'px';

    // After animation completes, set to auto for responsive behavior
    setTimeout(() => {
      if (filterMain.dataset.collapsed === 'false') {
        filterMain.style.height = 'auto';
        filterMain.style.overflow = 'visible';
      }
    }, 300);

    filterMain.dataset.collapsed = 'false';
  } else {
    // Before collapsing, set explicit height and hidden overflow
    filterMain.style.height = filterMain.scrollHeight + 'px';
    filterMain.style.overflow = 'hidden';

    // Force reflow then collapse
    setTimeout(() => {
      filterMain.style.height = '0px';
    }, 10);

    filterMain.dataset.collapsed = 'true';
  }
}

window.abtest = window.abtest || {};

// --- AB test defaults (config-first: set before consumers run) ---
window.abtest.quickaddColorLimit = 5;

// --- AB test setup functions (for hash triggers & console use) ---

window.abtest.setupFilterVersion = function (version) {
  if (version == 'a') {
    $('#oa-filter-sidebar').removeClass('oa-shop-filter__version-a');
    $('.oa-shop-filter__version-a').show(0);
    $('.oa-shop-filter__version-b').hide(0);
    $('#oa-filter-sidebar').addClass('oa-shop-filter__version-a');
  } else {
    $('#oa-filter-sidebar').removeClass('oa-shop-filter__version-a');
    $('.oa-shop-filter__version-a').hide(0);
    $('.oa-shop-filter__version-b').show(0);
  }
}

window.abtest.setupQuickaddColorCount = function (version) {
  window.abtest.quickaddColorLimit = version == 'a' ? 5 : 8;
  // Re-render already-loaded quick add color containers -
  $('.oa-prdct20-fashion__quickadd-container[data-colorloaded="true"]').each(function () {
    $(this).attr('data-colorloaded', 'false');
    $(this).attr('data-colorIsLoading', 'false');
    $(this).find('.oa-quick-add__colors').empty();
  });
};

window.abtest.setupSearchVersion = function (version) {
  window.abtest.searchVersion = version;
  document.documentElement.classList.remove('oa-search-version-a', 'oa-search-version-b');
  document.documentElement.classList.add('oa-search-version-' + version);
};

window.abtest.setupSearchVersion('b');

window.abtest.setupNewBadge = function (version) {
  window.abtest.newBadgeVersion = version;
  if (version == 'a') {
    $('.sidebar--color-item-text').show(0);
    $('.sidebar--color-item-box').css('margin-bottom', '0');
  } else {
    $('.sidebar--color-item-text').hide(0);
    $('.sidebar--color-item-box').css('margin-bottom', '8px');
  }
  // Re-render already-loaded quickadd color containers
  $('.oa-prdct20-fashion__quickadd-container[data-colorloaded="true"]').each(function () {
    $(this).attr('data-colorloaded', 'false');
    $(this).attr('data-colorIsLoading', 'false');
    $(this).find('.oa-quick-add__colors').empty();
  });
};

// Forced to version a. Set here so JS-rendered swatches pick it up, re-applied on
// DOM ready because this script runs in <head>, before server-rendered swatches exist.
window.abtest.setupNewBadge('a');
document.addEventListener('DOMContentLoaded', function () {
  window.abtest.setupNewBadge(window.abtest.newBadgeVersion || 'a');
});

window.abtest.setupHeaderBottomMultiline = function (version) {
  document.documentElement.classList.remove('header-bottom-multiline--a', 'header-bottom-multiline--b');
  document.documentElement.classList.add('header-bottom-multiline--' + version);
};

window.abtest.setupHpColours = function (version) {
  if (version == 'a') {
    $('.ab-hp-colours').show(0);
    if (window.initHpColoursSwiper) window.initHpColoursSwiper();
  } else {
    $('.ab-hp-colours').hide(0);
  }
};

window.abtest.setupHighlightCarouselVersion = function (version) {
  var visibleSelector = version == 'a'
    ? '.highlight-carousel-version-a'
    : '.highlight-carousel-version-b';

  if (version == 'a') {
    $('.highlight-carousel-version-a').show(0);
    $('.highlight-carousel-version-b').hide(0);
  } else {
    $('.highlight-carousel-version-a').hide(0);
    $('.highlight-carousel-version-b').show(0);
  }

  // Ensure images in the now-visible version are hydrated immediately.
  $(visibleSelector + ' img').each(function () {
    var $img = $(this);
    var dataSrc = $img.attr('data-src');
    var dataSrcset = $img.attr('data-srcset');

    if (dataSrc && !$img.attr('src')) {
      $img.attr('src', dataSrc);
    }
    if (dataSrcset && !$img.attr('srcset')) {
      $img.attr('srcset', dataSrcset);
    }

    this.loading = 'eager';
    if (this.decode) this.decode().catch(function () {});
  });

  // Swiper can mis-measure sliders that were hidden at initial load.
  // Refresh (or initialize) any visible highlight carousel after toggling version.
  setTimeout(function () {
    $('.teasing-highlight-carousel:visible .swiper').each(function () {
      if (this.swiper && typeof this.swiper.update === 'function') {
        this.swiper.update();
        if (this.swiper.lazy && typeof this.swiper.lazy.load === 'function') {
          this.swiper.lazy.load();
        }
      }
    });
    $(window).trigger('resize');
  }, 0);
};

window.abtest.setupTeasingHeroVersion = function (version) {
  var selectedVersion = version == 'b' ? 'b' : 'a';
  window.abtest.teasingHeroVersion = selectedVersion;

  if (selectedVersion == 'a') {
    $('.ab-teasing-hero-version-a').show(0);
    $('.ab-teasing-hero-version-b').hide(0);
  } else {
    $('.ab-teasing-hero-version-a').hide(0);
    $('.ab-teasing-hero-version-b').show(0);
  }

  document.documentElement.setAttribute('data-ab-teasing-hero', selectedVersion);
};

window.abtest.getTeasingHeroVersion = function () {
  var storageKey = 'oa_ab_teasing_hero_version';
  var legacyStorageKey = 'oa_ab_teasing_version';
  var queryParam = 'teasing_hero_ab';
  var legacyQueryParam = 'teasing_ab';
  var hash = (window.location.hash || '').toLowerCase();

  if (hash === '#teasing-hero-version-a' || hash === '#teasing-version-a') {
    try { localStorage.setItem(storageKey, 'a'); } catch (e) {}
    return 'a';
  }

  if (hash === '#teasing-hero-version-b' || hash === '#teasing-version-b') {
    try { localStorage.setItem(storageKey, 'b'); } catch (e) {}
    return 'b';
  }

  var params = new URLSearchParams(window.location.search);
  var fromQuery = (params.get(queryParam) || params.get(legacyQueryParam) || '').toLowerCase();
  if (fromQuery === 'a' || fromQuery === 'b') {
    try { localStorage.setItem(storageKey, fromQuery); } catch (e) {}
    return fromQuery;
  }

  try {
    var stored = localStorage.getItem(storageKey) || localStorage.getItem(legacyStorageKey);
    if (stored === 'a' || stored === 'b') {
      return stored;
    }
  } catch (e) {}

  var randomVersion = Math.random() < 0.5 ? 'a' : 'b';
  try { localStorage.setItem(storageKey, randomVersion); } catch (e) {}
  return randomVersion;
};

// Backward-compatible aliases
window.abtest.setupTeasingVersion = window.abtest.setupTeasingHeroVersion;
window.abtest.getTeasingVersion = window.abtest.getTeasingHeroVersion;

document.documentElement.classList.add('header-bottom-multiline--a');

// --- Hash overrides ---
(function () {
  var hash = window.location.hash;

  if (hash === '#quickadd-color-count-a') {
    window.abtest.setupQuickaddColorCount('a');
  } else if (hash === '#quickadd-color-count-b') {
    window.abtest.setupQuickaddColorCount('b');
  } else if (hash === '#new-badge-a') {
    window.abtest.setupNewBadge('a');
  } else if (hash === '#new-badge-b') {
    window.abtest.setupNewBadge('b');
  } else if (hash === '#header-multiline-a') {
    window.abtest.setupHeaderBottomMultiline('a');
  } else if (hash === '#header-multiline-b') {
    window.abtest.setupHeaderBottomMultiline('b');
  } else if (hash === '#hp-colours-a') {
    window.abtest.setupHpColours('a');
  } else if (hash === '#hp-colours-b') {
    window.abtest.setupHpColours('b');
  }
    
  if (hash === '#highlight-carousel-a') {
    window.abtest.setupHighlightCarouselVersion('a');
  } else if (hash === '#highlight-carousel-b') {
    window.abtest.setupHighlightCarouselVersion('b');
  }

  if (hash === '#search-version-a') {
    window.abtest.setupSearchVersion('a');
  } else if (hash === '#search-version-b') {
    window.abtest.setupSearchVersion('b');
  }

  if (hash === '#teasing-version-a') {
    window.abtest.setupTeasingHeroVersion('a');
  } else if (hash === '#teasing-version-b') {
    window.abtest.setupTeasingHeroVersion('b');
  }
})();
